import React from 'react';

const ChartContainer = ({ title, children, className = '' }) => {
  return (
    <div className={`card-dark p-6 ${className}`}>
      {title && (
        <h3 className="text-lg font-semibold text-dark-text mb-4 border-b border-gray-700 pb-2">
          {title}
        </h3>
      )}
      <div className="relative h-64 sm:h-80">
        {children}
      </div>
    </div>
  );
};

export default ChartContainer; 